const EditIcon = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.05 3.50002L4.20834 10.7417C3.95 11.0167 3.7 11.5584 3.65 11.9334L3.34167 14.6334C3.23334 15.6084 3.93334 16.275 4.9 16.1084L7.58334 15.65C7.95834 15.5834 8.48334 15.3084 8.74167 15.025L15.5833 7.78335C16.7667 6.53335 17.3 5.10835 15.4583 3.36668C13.625 1.64168 12.2333 2.25002 11.05 3.50002Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.90834 4.70831C10.2667 7.00831 12.1333 8.76665 14.45 8.99998" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.5 18.8333H17.5" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default EditIcon;
